import {
  IGetLoyaltyRollUpTheRimTimelineEventSummaryQuery,
  ILoyaltyRollUpTheRimTimelineEventSummaryEntry,
} from 'generated/rbi-graphql';

import { OfferPrizes } from './types';

export const getShareCountProperty = (
  eventsArray: ILoyaltyRollUpTheRimTimelineEventSummaryEntry[],
  countryCode: string
): number => {
  const eventSummaryEntry = eventsArray.find(item => item && item.eventId === countryCode) || {
    count: 0,
  };
  return eventSummaryEntry.count;
};

export const isTimelineEventSummaryEntryArray = (
  array: unknown
): array is ILoyaltyRollUpTheRimTimelineEventSummaryEntry[] => {
  return (
    Array.isArray(array) &&
    (array as ILoyaltyRollUpTheRimTimelineEventSummaryEntry[]).length > 0 &&
    (array as ILoyaltyRollUpTheRimTimelineEventSummaryEntry[])[0].eventId.includes('RUTR')
  );
};

export const determineRemainingRollsCount = (
  eventId: string,
  eventsSummaryData: IGetLoyaltyRollUpTheRimTimelineEventSummaryQuery
): number => {
  const events =
    eventsSummaryData &&
    eventsSummaryData.getLoyaltyRollUpTheRimTimelineEventSummary &&
    eventsSummaryData.getLoyaltyRollUpTheRimTimelineEventSummary.events;

  if (!isTimelineEventSummaryEntryArray(events)) {
    return 0;
  }
  return getShareCountProperty(events, eventId);
};

export const copyToClipboard = (text: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const range = document.createRange();
    range.selectNodeContents(document.body);
    document.getSelection()!.addRange(range);
    let success = false;
    const listener = (e: ClipboardEvent) => {
      e.clipboardData!.setData('text/plain', text);
      e.preventDefault();
      success = true;
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
    document.getSelection()!.removeAllRanges();

    if (success) {
      resolve();
    } else {
      reject();
    }
  });
};

export const isOfferPrize = (rewardKey: string) => {
  return Object.values(OfferPrizes).includes(rewardKey as OfferPrizes);
};

export const isLoyaltyPointsPrize = (rewardKey: string) => {
  // Make sure the rewardKey is matching the `win-X-points`
  const rxStatrWithWin = /^win-/;
  const rxEndsWithPoints = /-points$/;
  return rxStatrWithWin.test(rewardKey) && rxEndsWithPoints.test(rewardKey);
};

export const isTimCardPrize = (rewardKey: string) => {
  // Make sure the rewardKey is matching the `win-25-timcard`
  return rewardKey === 'win-25-timcard';
};

export const getLoyaltyPointsfromKey = (rewardKey: string) => {
  const result = /win-(.*)-points/.exec(rewardKey);
  return result?.length ? Number(result[1]) : 0;
};
